var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMvl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#072D3A",
    fillRule: "evenodd",
    d: "M16.034 8.426c-.495 1.946-1.55 6.05-1.81 6.903c-.09.29-.25.722-.57 1.089c-.349.397-.977.725-1.654.725c-.792 0-1.257-.313-1.647-.767c-.31-.36-.445-.789-.503-.975l-.017-.052l-.01-.027l-1.802-6.93c.005.018-.013-.045-.095-.113c-.07-.058-.218-.147-.519-.147c-.381 0-.55.432-.55.868c0 .47-.393.857-.857.857A.865.865 0 0 1 5.143 9v-.64c0-.288.26-.792.591-1.172a2.17 2.17 0 0 1 1.674-.76c1.381 0 2.084.895 2.245 1.55l1.784 6.855l.004.012c.271.815.944.733 1.175-.02c.246-.805 1.295-4.885 1.795-6.85l.003-.013l.004-.012c.176-.613.876-1.521 2.239-1.521c.735 0 1.3.328 1.667.759c.344.403.533.916.533 1.37v7.728c0 .47-.393.857-.857.857a.86.86 0 0 1-.858-.852V8.47a.48.48 0 0 0-.486-.337c-.275 0-.423.084-.503.149a.5.5 0 0 0-.117.142zM6 13.286c.473 0 .857.39.857.873v2.111a.865.865 0 0 1-.857.873a.865.865 0 0 1-.857-.873v-2.111c0-.482.384-.873.857-.873",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8B739",
    d: "M4.94 12.118a.773.773 0 0 1 0-1.093l.513-.513a.773.773 0 0 1 1.093 0l.513.513a.774.774 0 0 1 0 1.093l-.513.513a.77.77 0 0 1-1.093 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvl);
export default __webpack_public_path__ + "static/media/mvl.e61941b5b180f0901bfbdd93a70f9617.svg";
export { ForwardRef as ReactComponent };